import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

const useStyles = makeStyles((theme) => ({
  rootAccordionSummary: {
    borderBottom: ` 1px solid ${theme.palette.KenColors.grey4}`,

    '&> .MuiAccordionSummary-expandIconWrapper': {
      color: theme.palette.KenColors.neutral900,
    },
  },
  label: {
    color: theme.palette.KenColors.neutral900,
    textAlign: 'left',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '500',
      'font-size': '14px',
      'line-height': '100%',
      color: theme.palette.KenColors.neutral900,
    },
  },
  listContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '8px 0 16px 8px',
    },
  },
}));

export default function KenAccordion(props) {
  const { children, label, applicationState, changeExpand, expandedVal, handleEdit, noedit, accordionVal } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  const enableSave = applicationState?.summaryEdit === accordionVal;
  const applicationCompleted = applicationState?.applicationData?.application?.applicationStatus === "Submitted" ? true : false;
  return (
    <Box margin={isMobileScreen ? '16px' : undefined}>
      <Accordion elevation={0} expanded={expandedVal} onChange={changeExpand}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" classes={{ root: classes.rootAccordionSummary }}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
            <Typography variant="body2" sx={{ marginLeft: '-16px', textTransform: "capitalize" }} className={classes.label}>
              {label}
            </Typography>
            {!applicationCompleted && !noedit && expandedVal && handleEdit && (
              <Box mr={'20px'}>
                {!enableSave ? (
                  <ModeEditIcon
                    color="rgba(0, 0, 0, 0.1)"
                    style={{ fontSize: '22px' }}
                    onClick={() => {
                      handleEdit(accordionVal);
                    }}
                  />
                ) : null}
              </Box>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails className={classes.listContainer}>
          <Box paddingY={'20px'}>{children}</Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
